import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './theme.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext';
import { initializeSessionStorage } from './utils/sessionStorage';
import { hideNativeSplash, initializeNativeShell } from './platform/lifecycle';

const mountApp = async () => {
  // Native debe recuperar Keychain/Keystore antes de que AuthContext intente
  // restaurar la sesión. En web esta inicialización es inmediata.
  await initializeSessionStorage();
  await initializeNativeShell();

  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <BrowserRouter>
        <AuthProvider><App /></AuthProvider>
      </BrowserRouter>
    </React.StrictMode>
  );

  window.requestAnimationFrame(() => hideNativeSplash());
};

mountApp().catch(error => {
  console.error('No se pudo iniciar Pulsora.', error);
  const root = document.getElementById('root');
  if (root) root.innerHTML = '<div class="app-loading">No se pudo iniciar Pulsora. Cierra y abre la aplicación nuevamente.</div>';
});

reportWebVitals();
